import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import './ModernLanding.css';
import androidLogoImage from '../../images/getongp.svg';
import iosLogoImage from '../../images/getonas.svg';
import phoneStock from '../../images/phone_stock.png';
import appscreen from '../../images/iframe1.png';
import appscreen1 from '../../images/iframe2.png';
import appscreen2 from '../../images/iframe3.png';
import appscreen3 from '../../images/iframe4.png';
import appscreen4 from '../../images/iframe5.png';
import appscreen5 from '../../images/iframe6.png';
import appscreen6 from '../../images/iframe7.png';
import appscreen7 from '../../images/iframe8.png';

const screenshots = [
  appscreen,
  appscreen1,
  appscreen2,
  appscreen3,
  appscreen4,
  appscreen5,
  appscreen6,
  appscreen7,
];

const termsUrl =
  'https://firebasestorage.googleapis.com/v0/b/ziel-studienkolleg.appspot.com/o/Documents%2FNutzungsvertrag_der_Plattform.pdf?alt=media&token=9e68fe40-f9b0-4e4e-9935-6ee5e7b58102';
const privacyUrl = '/datenschutz/';

const ModernLanding = ({
  totalNumber,
  examNumber,
  themesNumber,
  isGoogleLoading,
  authError,
  onGoogleSignIn,
}) => (
  <div className="auth-landing">
    <main className="auth-shell">
      <section className="auth-hero">
        <div className="auth-hero__copy">
          <span className="auth-eyebrow">Vorbereitung aufs Studienkolleg</span>
          <h1>Dein Ziel ist das Studienkolleg?</h1>
          <p>
            ZielStk hilft dir, das passende Studienkolleg zu finden und dich
            sicher auf die Aufnahmeprüfung vorzubereiten.
          </p>

          <div className="auth-store-links" aria-label="App herunterladen">
            <a
              href="https://play.google.com/store/apps/details?id=com.appdroid.develop.zielstk"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={androidLogoImage} alt="Bei Google Play herunterladen" />
            </a>
            <a
              href="https://apps.apple.com/us/app/zielstk-studienkolleg/id1480404410"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={iosLogoImage} alt="Im App Store herunterladen" />
            </a>
          </div>
        </div>

        <div className="auth-phone-preview" aria-label="ZielStk App-Ansichten">
          <div className="auth-phone-preview__glow" />
          <AliceCarousel
            autoPlay
            autoPlayInterval={3200}
            animationDuration={650}
            disableButtonsControls
            disableDotsControls
            infinite
            items={screenshots.map((image, index) => (
              <img
                key={image}
                src={image}
                className="auth-phone-preview__image"
                alt={`App-Ansicht ${index + 1}`}
              />
            ))}
          />
        </div>
      </section>

      <section className="auth-content-grid">
        <div className="auth-card">
          <span className="auth-eyebrow">Persönlicher Bereich</span>
          <h2>Starte jetzt mit deiner Vorbereitung</h2>
          <p className="auth-card__intro">
            Melde dich mit Google an oder nutze deine E-Mail-Adresse.
          </p>

          <button
            type="button"
            className="google-auth-button"
            onClick={onGoogleSignIn}
            disabled={isGoogleLoading}
          >
            <img
              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
              alt=""
              aria-hidden="true"
            />
            <span>{isGoogleLoading ? 'Google wird geöffnet…' : 'Mit Google anmelden'}</span>
          </button>

          <div className="auth-divider"><span>oder</span></div>

          <div className="email-auth-embed">
            <div id="firebaseui-auth-container" />
          </div>

          {authError && <p className="auth-error" role="alert">{authError}</p>}

          <p className="email-auth-legal">
            Mit der Anmeldung akzeptierst du die{' '}
            <a href={termsUrl} target="_blank" rel="noopener noreferrer">
              Nutzungsbedingungen
            </a>{' '}
            und die{' '}
            <a href={privacyUrl} target="_blank" rel="noopener noreferrer">
              Datenschutzerklärung
            </a>.
          </p>
        </div>

        <div className="auth-stats" aria-label="Vorteile von ZielStk">
          <article>
            <strong>{totalNumber ?? '—'}</strong>
            <span>Aufgaben zu {themesNumber ?? '—'} Themen</span>
          </article>
          <article>
            <strong>{examNumber ?? '—'}</strong>
            <span>Aufgaben aus vergangenen Aufnahmeprüfungen</span>
          </article>
          <article>
            <strong>Flexibel</strong>
            <span>Zahle nur für die Materialien, die du wirklich brauchst</span>
          </article>
        </div>
      </section>

      <section className="auth-benefit">
        <div>
          <span className="auth-eyebrow">Immer dabei</span>
          <h2>Lerne in deinem eigenen Tempo</h2>
          <p>
            Aufgaben, Themen und hilfreiche Materialien sind auf der Website
            und in der mobilen App verfügbar.
          </p>
        </div>
        <img src={phoneStock} alt="ZielStk App auf einem Smartphone" />
      </section>
    </main>
  </div>
);

export default ModernLanding;
